import React from 'react';
import {
  Car, Star, Calendar, Link2, CheckCircle, Check, Zap, BarChart2,
  Wrench, Disc, Settings, Octagon, Snowflake, MapPin, ArrowRight,
  TrendingUp, Droplet, Search, MoveHorizontal, Scale,
  AlertTriangle, ShieldCheck, ShieldX, Clock, Frown, ChevronDown,
  Quote, Lock, Users, Sparkles, ThumbsUp, Smile, DollarSign,
  Percent, BadgeCheck, Eye, Compass, Rocket, HandCoins,
} from 'lucide-react';

const ICON_MAP = {
  'car':              Car,
  'star':             Star,
  'calendar':         Calendar,
  'link-2':           Link2,
  'check-circle':     CheckCircle,
  'check':            Check,
  'zap':              Zap,
  'bar-chart-2':      BarChart2,
  'wrench':           Wrench,
  'disc':             Disc,
  'settings':         Settings,
  'octagon':          Octagon,
  'snowflake':        Snowflake,
  'map-pin':          MapPin,
  'arrow-right':      ArrowRight,
  'trending-up':      TrendingUp,
  'droplet':          Droplet,
  'search':           Search,
  'move-horizontal':  MoveHorizontal,
  'scale':            Scale,
  'alert-triangle':   AlertTriangle,
  'shield-check':     ShieldCheck,
  'shield-x':         ShieldX,
  'clock':            Clock,
  'frown':            Frown,
  'chevron-down':     ChevronDown,
  'quote':            Quote,
  'lock':             Lock,
  'users':            Users,
  'sparkles':         Sparkles,
  'thumbs-up':        ThumbsUp,
  'smile':            Smile,
  'dollar-sign':      DollarSign,
  'percent':          Percent,
  'badge-check':      BadgeCheck,
  'eye':              Eye,
  'compass':          Compass,
  'rocket':           Rocket,
  'hand-coins':       HandCoins,
};

export default function Icon({ name, size = 24, strokeWidth = 2, style = {}, ...rest }) {
  const Component = ICON_MAP[name];
  if (!Component) return null;
  return <Component size={size} strokeWidth={strokeWidth} style={style} {...rest} />;
}
